
            const data = {"name":"speech-bubble-connector","data":{"width":"32","height":"33","viewBox":"0 0 32 33","data":"<path pid=\"0\" d=\"m0 32.5 32-32H0v32Z\" _fill=\"#F7F7F7\"/>","originalColors":[{"type":"fill","color":"#F7F7F7"}],"stopColors":[]}}
        
                    module.exports = data
                    